import type { State } from "../../State";
import type BaseModel from "../../models/BaseModel";
import { ChannelType, channelTypeInfo } from "../../models/ChannelType";
import { deviceMetrics } from "./equipment";
import { label, sorted, type TechnicalReport } from "./types";

/** Counts live native objects and their actual connections, including nested room equipment. */
export function statisticsReport(app: State): TechnicalReport {
  const rows: string[][] = [];
  const counts = new Map<string, number>();
  for (const consumer of sorted(app.allConsumers())) {
    const name = `${consumer.isDali ? "DALI · " : ""}${app.translate(`channelType.${consumer.channelType}`, consumer.channelType)}`;
    counts.set(name, (counts.get(name) || 0) + 1);
  }
  for (const [name, count] of counts) rows.push([name, String(count)]);
  const buttons = sorted(app.allButtons());
  const categories = [
    { name: "Taster", devices: buttons.filter(button => !button.isSensor && !button.isDecentralActor) },
    { name: "Sensoren", devices: buttons.filter(button => button.isSensor) },
    { name: "Dezentrale Aktoren", devices: buttons.filter(button => button.isDecentralActor) },
  ];
  for (const category of categories) {
    let connections = 0;
    for (const device of category.devices) for (const channel of device.channels.asArray()) connections += channel.connections.size;
    rows.push([category.name, String(category.devices.length)], [`Verknüpfungen · ${category.name}`, String(connections)]);
  }
  rows.push(["Aktoren", String(sorted(app.allActors()).filter(actor => !channelTypeInfo(actor.channelType).isSupply && actor.channelType !== ChannelType.Lan).length)]);
  for (const floor of sorted(app.floors.asArray())) {
    let bus = 0;
    for (const room of sorted(floor.rooms.asArray())) for (const button of sorted(room.allButtons)) bus += deviceMetrics(button.template).bus;
    rows.push([`Busstrom Raumgeräte · ${label(floor)}`, `${bus} mA`]);
  }
  rows.push(["Szenen", String(sorted(app.allScenes()).filter(scene => !scene.isMultiplexer).length)],
    ["Multiplexer", String(sorted(app.allMultiplexers()).length)]);
  const addresses = app.allLevel3GroupAddresses();
  let usages = 0;
  for (const address of addresses) for (const signal of address.getSignalBackpointers()) {
    const parent = signal.parent as BaseModel | undefined;
    if (parent && !parent.isConsumer && !parent.isMultiplexer) usages++;
  }
  rows.push(["Gruppenadressen", String(addresses.length)], ["Verwendungen Gruppenadressen", String(usages)]);
  return { sections: [{ title: "Projektstatistik", hierarchy: ["", ""], tables: [{ columns: ["Merkmal", "Anzahl / Wert"], rows }] }] };
}
